import { render, staticRenderFns } from "./Novo-Produto2.vue?vue&type=template&id=1535c0cc&scoped=true&"
import script from "./Novo-Produto2.vue?vue&type=script&lang=js&"
export * from "./Novo-Produto2.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Produto2.vue?vue&type=style&index=0&id=1535c0cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535c0cc",
  null
  
)

export default component.exports